import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{attrs:{"min-width":"20vw","align":"center","justify":"center","outlined":""}},[_c(VCardTitle,[_c(VListItem,[_c(VListItemTitle,[_c('h2',[_vm._v(_vm._s(_vm.$t('deleteStrategy')))])]),_c(VSpacer),_c(VListItemAction,[_c(VIcon,{staticClass:"icon",attrs:{"icon":""},on:{"click":_vm.cancelDelete}},[_vm._v("fa-times")])],1)],1)],1),_c(VCardText,{staticClass:"px-7 py-7"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('areYouSureToDeleteStrategy',{strategyName: _vm.strategy.name}))}}),_c(VBtn,{on:{"click":_vm.deleteStrategy}},[_vm._v(_vm._s(_vm.$t('yesDeleteIt')))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }